import "./MaintenancePage.css";
import { maintenance, EMAIL_ADDRESS, EMAIL_HREF } from "../../Data/siteContent";
import LogoMain from "../../resources/images/logo.png";

function MaintenancePage() {
  return (
    <div className="maintenance-page">
      <div className="maintenance-content">
        <img src={LogoMain} alt="Dawned Instruments" className="maintenance-logo" />
        <h2>{maintenance.title}</h2>
        <p>
          {maintenance.message}
          <br />
          {maintenance.patience}
        </p>
        <p className="maintenance-contact">
          {maintenance.contact} <a href={EMAIL_HREF}>{EMAIL_ADDRESS}</a>
        </p>
      </div>
    </div>
  );
}

export default MaintenancePage;
